<template>
  <div class="list-container">
    <div v-show="!dialogFormVisible && !invoiceVisible">
      <div class="filter-container">
        <template v-if="!isFilterCollapse">
          <template v-for="(field) in FilterField" :key="field.fieldKey">
            <div class="filter-box" >
              <span class="label">{{field.fieldName}}</span>
              <el-input
                v-if="field.componentType === 'el-input'"
                v-model="listQuery[field.fieldKey]"
                style="width: 200px"
                :size="t('table.btnSize')"
                class="filter-item"
                clearable
                @keyup.enter="handleFilter"
              />
              <el-select :filterable="true" v-else-if="field.componentType === 'el-select'" v-model="listQuery[field.fieldKey]" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @focus="handleFilterFocus(field)" @change="handleFilter">
                <el-option
                  v-for="item in handleFilterOptions(field)"
                  :key="item.id"
                  :label="item.mark"
                  :value="item.id"
                />
              </el-select>
            </div>
          </template>
          <div class="filter-box">
            <span class="label">开始日期</span>
            <el-date-picker
              v-model="listQuery.startTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box">
            <span class="label">结束日期</span>
            <el-date-picker
              v-model="listQuery.endTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
        </template>
        <div class="filter-box">
          <el-button
            v-waves
            class="filter-item "
            type="primary"
            :size="t('table.btnSize')"
            @click="handleFilter"
          >
            {{ t("table.search") }}
          </el-button>
          <el-button
            v-permission="{ pkey: `${permissionName}_ADD` }"
            class="filter-item"
            type="primary"
            :size="t('table.btnSize')"
            @click="handleCommand('add')"
          >
            {{ t("table.add") }}
          </el-button>
          <el-button
            v-permission="{ pkey: `${permissionName}_INVOICE` }"
            class="filter-item"
            type="primary"
            :size="t('table.btnSize')"
            @click="handleCommand('incoice')"
          >
            发票申请
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="handleReset"
          >
            {{ t("table.reset") }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="isFilterCollapse = !isFilterCollapse"
          >
            {{isFilterCollapse ? '展开' : '收起'}}
          </el-button>
          <span class="svg-icon cursor mr-10 ml-10" @click="handleCommand('refresh')" >
            <i class="icon-tubiao-27 iconfont"/>
          </span>
          <span class="svg-icon cursor" @click="handleCommand('column')">
            <i class="icon-tubiao-28 iconfont"/>
          </span>
        </div>
      </div>
      <div class="split-table-layout">
        <!-- 主表区域 -->
        <div
          class="split-pane-top vue-grid-item"
          :style="{ height: isSubMenuCollapse ? '100%' : `${topHeight}px` }"
        >
          <TableList
              :ref="el => { if (el) tableListRef[0] = el }"
              v-loading="listLoading"
              :dataList="list"
              :columnAllData="columnAllData?.filter((item: any) => !hiddenColumnLabels.some((labelValue: string) => item.fieldName === labelValue))"
              :tableName="TableName"
              :permissionName="permissionName"
              :showSelection="true"
              :isShowPagination="false"
              :handleDefaultWidth="120"
              :highlightCurrentRow="true"
              :layoutHeight="true"
              :newHpx="newHpx"
              :canRefresh="false"
              :canChangeColumn="false"
              :canCommand="false"
              style="height:100% ;overflow:hidden;"
              @row-click="handleRowClick"
              @command-change="handleCommand"
            >
              <template v-slot:operation-action="scope">
                <CommandRender
                  :scopeRow='scope.row'
                  :codeList="btnList"
                  :permissionName="permissionName"
                  @command-change="handleCommand"
                />
              </template>
            </TableList>
            <el-pagination
              class="mt-20"
              v-show="total > 0"
              :total="total"
              v-model:currentPage="listQuery.page"
              :page-size="listQuery.size"
              :page-sizes="pageSizes"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              layout="total, sizes, prev, pager, next"
            />
        </div>

        <!-- 水平交互分割线 -->
        <TableSplitter
          v-if="!isSubMenuCollapse && tabList.length"
          @drag-start="handleSplitterDragStart"
          @drag-move="handleSplitterDragMove"
          @drag-end="handleSplitterDragEnd"
        />

        <!-- 子表区域 -->
        <div
          v-show="!isSubMenuCollapse && tabList.length"
          class="split-pane-bottom"
          :style="{ height: `${bottomHeight}px` }"
        >
          <div class="clearfix tab-title btn-container mt-10">
                <ul class="tab-title_left fl">
                  <li v-for="item in tabList" :key="item.id" :class="{ active: activeTab === item.id }" @click="handleTabClick(item)">{{item.name}}</li>
                </ul>
              </div>
              <ContactList v-if="activeTab === 1" ref="ContactList" :id="activeId"/>
              <MarketFee v-if="activeTab === 4" ref="MarketFee" :id="activeId" :marketFeeCanCommand="false"/>
              <TraceInfo v-if="activeTab === 3" ref="TraceInfo" :id="activeId" api="business"/>
        </div>
      </div>
    </div>
     <FormComponent
      v-if="dialogFormVisible"
      :id="activeId"
      :initFormData="initFormData"
      :fromFieldData="fromFieldData"
      :dialogFormVisible="dialogFormVisible"
      :api="'business'"
      :commandState="commandState"
      @update:visibel="() => dialogFormVisible = false"
      @submit="handleSubmit(formData)"
    />
    <InvoiceFormCom
      v-if="invoiceVisible"
      :dialogFormVisible="invoiceVisible"
      :api="'invoice'"
      from="business"
      :selectionBusiness="selectionArray"
      :selectcCustomerCompanyId="selectcCustomerCompanyId"
      :selectcCustomerTitleId="selectcCustomerTitleId"
      :selectoOderTaxRate="selectoOderTaxRate"
      @update:visibel="() => invoiceVisible = false"
      @submit="handleInvoiceSubmit(formData)"
    />
    <el-button type="primary" circle @click="handleSubMenuCollapse" class="subMenuCollapseBtn" v-if="!dialogFormVisible"> {{isSubMenuCollapse ? '展开' : '收起'}}</el-button>
  </div>
</template>

<script lang='ts'>
import TableSplitter from '@/components/common/TableSplitter.vue'
import { useTableSplitter } from '@/composables/useTableSplitter'
import { defineComponent, reactive, toRefs, onMounted, ref, watch } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { cloneDeep } from 'lodash'
import { getDetailById, deleteById, getPageList, postUrl } from '@/apis/Dictionary'
import { getPageList as getUrlList } from '@/apis/Form'
import { getUserDetailByUserId } from '@/apis/user'

import { CostModel, ArrayRowsItem } from '@/model/Index'

import FormComponent from '@/components/Form/index.vue'
import TableList from '@/components/common/TableList.vue'
import InvoiceFormCom from '@/views/invoice/From.vue'

import ContactList from '@/views/business/businessList/contact/Index.vue'
import MarketFee from '@/views/business/businessList/businessMarketFee/Index.vue'
import TraceInfo from '@/components/traceInfo/Index.vue'
import { TableName, permissionName } from '@/utils/enum'
import { FromFieldData } from '@/views/business/businessList/FieldFrom'
import { TableField } from '@/views/business/businessList/FieldTable'
import { defaultDate, pageVo, pageSizes } from '@/utils/index'
import mixin from '@/mixins/index'
import CommandRender from '@/components/common/CommandRender.vue'
import { FilterField } from './FilterField'

import { useI18n } from 'vue-i18n'
export default defineComponent({
  name: 'Invoicebusiness',
  components: {
    TableSplitter,
    FormComponent,
    TableList,
    ContactList,
    TraceInfo,
    MarketFee,
    InvoiceFormCom,
    CommandRender
  },
  setup() {
    const { t } = useI18n()
    const tableListRef = ref([])

    const dataMap = reactive({
      TableName: TableName.TABLE_INVOICE_BUSINESS,
      permissionName: permissionName.INVOICE_BUSINESS,
      initFormData: cloneDeep(FromFieldData),
      fromFieldData: cloneDeep(FromFieldData),
      columnAllData: TableField,
      hiddenColumnLabels: '开票状态、开票日期、发票号码、发票金额、紧急程度、预计完成天数、维修类型、业务分类'.split('、'),
      FilterField,

      activeId: 0,
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        name: undefined,
        brand: undefined,
        model: undefined,
        serial: undefined,
        type: undefined,
        urgentId: undefined,
        customerCompanyName: undefined,
        customerCompanyContactName: undefined,
        customerCompanyContactPhone: undefined,
        salesManId: undefined,
        engineerId: undefined,
        outsourceCompanyName: undefined,
        outsourceCompanyContactName: undefined,
        outsourceCompanyContactPhone: undefined,
        startTime: '',
        endTime: '',
        status: undefined,
        ...pageVo
      },
      pageSizes,
      dialogFormVisible: false,
      invoiceVisible: false,
      selectcCustomerTitleId: 0,
      selectoOderTaxRate: 0,
      tabList: [
        { name: '联系人', id: 1 }
        // { name: '市场费', id: 4 },
        // { name: '跟踪信息', id: 3 }
      ],
      activeTab: 1,

      salesManId: '',
      newHpx: 0,
      statusOption: [],
      urgentOption: [],
      businessTypeOption: [],
      engineerOption: [],
      salesManOption: [],
      selectionArray: [],
      commandState: 'edit',
      selectcCustomerCompanyId: 0,
      achieveType: '',
      btnList: [],
      async handleCommand(command: string, val?: any) {
        dataMap.commandState = command
        switch (command) {
          case 'add':
            dataMap.handleCreate()
            break
          case 'copy':
          case 'edit':
            dataMap.handleUpdate(val)
            break
          case 'delete':
            dataMap.handleDelete(val)
            break
          case 'refresh':
            dataMap.handleFilter()
            break
          case 'column':
            (tableListRef.value[0] as any).setColumnVisible = true
            break
          case 'current-change':
            dataMap.handleCurrentChange(val)
            break
          case 'size-change':
            dataMap.handleSizeChange(val)
            break
          case 'selection':
            dataMap.selectionArray = val
            break
          case 'incoice': {
            if (!dataMap.selectionArray.length) {
              return ElMessage.error({
                message: '请选择业务',
                duration: 1000
              })
            }
            dataMap.selectcCustomerCompanyId = dataMap.selectionArray[0].customerCompanyId
            dataMap.selectcCustomerTitleId = dataMap.selectionArray[0].titleId
            dataMap.selectoOderTaxRate = dataMap.selectionArray[0].orderTaxRate

            const limitNo = 8
            if (dataMap.selectionArray.length > limitNo) {
              const businessNameList = Array.from(new Set(dataMap.selectionArray.map(item => item.name)))
              if (businessNameList.length > limitNo) {
                return ElMessage.error(`开票明细的业务最多不超过${limitNo}条！`)
              }
            }

            for (let i = 0; i < dataMap.selectionArray.length; i++) {
              const item = dataMap.selectionArray[i]
              if (dataMap.selectcCustomerCompanyId !== item.customerCompanyId) {
                return ElMessage.error({
                  message: '所选客户公司名称不一致！',
                  duration: 1000
                })
              }
              if (dataMap.selectcCustomerTitleId !== item.titleId) {
                return ElMessage.error({
                  message: '所选业务的发票抬头不一致！',
                  duration: 1000
                })
              }
              if (dataMap.selectoOderTaxRate !== item.orderTaxRate) {
                return ElMessage.error({
                  message: '所选业务税率不一致！',
                  duration: 1000
                })
              }
            }
            const businessIds = dataMap.selectionArray.map((kk: any) => kk.id)
            postUrl('business/actions/verify/invoice', { ids: businessIds }).then(() => {
              dataMap.invoiceVisible = true
            })
          }
            break
        }
      },
      handleRowClick(row: any) {
        dataMap.activeId = row.id
      },
      getList() {
        dataMap.listLoading = true
        getPageList('business', { ...dataMap.listQuery, pageType: 'INVOICE' }).then((res: any) => {
          dataMap.list = res.data || []
          dataMap.total = res.total
          dataMap.listLoading = false
          dataMap.activeId = dataMap.list.length ? dataMap.list[0].id : 0
        }).catch(() => {
          dataMap.listLoading = false
        })
      },
      handleReset() {
        dataMap.listQuery = {
          name: undefined,
          brand: undefined,
          model: undefined,
          serial: undefined,
          type: undefined,
          urgentId: undefined,
          customerCompanyName: undefined,
          customerCompanyContactName: undefined,
          customerCompanyContactPhone: undefined,
          salesManId: undefined,
          engineerId: undefined,
          outsourceCompanyName: undefined,
          outsourceCompanyContactName: undefined,
          outsourceCompanyContactPhone: undefined,
          startTime: defaultDate[0],
          endTime: defaultDate[1],
          status: undefined,
          ...pageVo
        }
        dataMap.handleFilter()
      },
      handleFilter() {
        const { startTime, endTime } = dataMap.listQuery
        const tempsStart = startTime ? new Date(startTime).getTime() : 0
        const tempdEnd = endTime ? new Date(endTime).getTime() : 0
        if (!tempsStart) {
          return ElMessage.error({
            message: '请选择开始时间',
            duration: 1000
          })
        } else if (!tempdEnd) {
          return ElMessage.error({
            message: '请选择结束时间',
            duration: 1000
          })
        } else if (tempsStart > tempdEnd) {
          return ElMessage.error({
            message: '开始时间必须小于结束时间',
            duration: 1000
          })
        }

        dataMap.getList()
      },

      handleCreate() {
        dataMap.activeId = 0
        dataMap.fromFieldData = cloneDeep(dataMap.initFormData)
        dataMap.dialogFormVisible = true
      },
      handleUpdate(row: any) {
        dataMap.activeId = row.id
        dataMap.fromFieldData = cloneDeep(dataMap.initFormData)
        getDetailById('business', row.id).then((res: any) => {
          dataMap.fromFieldData.forEach((k: any) => {
            k.formList.forEach(async(field: any) => {
              field.value = res[field.fieldKey] || field.value
              switch (field.fieldKey) {
                case 'customerContactIds': {
                  const result = await getUrlList(field.config.url, { companyId: res.customerCompanyId })
                  field.option = result
                }
                  break
                case 'customerCompanyId': {
                  const result = await getUrlList('customerCompany/dropdown', {
                    ids: res.customerCompanyId
                  })
                  field.option = result.map((item: any) => {
                    return {
                      ...item
                    }
                  })
                }
                  break
                case 'salesManId': {
                  const result = await getUserDetailByUserId(res.salesManId)
                  field.option = [{
                    id: result.id,
                    name: result.name
                  }]
                }
                  break
              }
            })
          })
          dataMap.dialogFormVisible = true
        })
      },
      handleDelete(row: any) {
        ElMessageBox.confirm(
          '确定要删除选中数据吗？',
          '删除',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        )
          .then(() => {
            deleteById('business', row.id).then(() => {
              dataMap.getList()
              ElMessage({
                message: '删除成功',
                type: 'success',
                duration: 1000
              })
            })
          })
      },
      handleSubmit() {
        dataMap.getList()
      },
      handleInvoiceSubmit() {
        dataMap.getList()
      },
      handleCurrentChange(page?: any) {
        dataMap.listQuery.page = page
        dataMap.getList()
      },
      handleSizeChange(size: any) {
        dataMap.listQuery.size = size
        dataMap.handleCurrentChange(1)
      },
      getDropdownList() {
        getUrlList('dropdown/BusinessStatus').then((res: any) => {
          dataMap.statusOption = res || []
        })
        getUrlList('urgency/dropdown').then((res: any) => {
          dataMap.urgentOption = res || []
        })
        getUrlList('dropdown/BusinessType').then((res: any) => {
          dataMap.businessTypeOption = res || []
        })
      },
      handleEngineerFocus() {
        getUrlList('user/dropdown/engineers?all=true').then((res: any) => {
          dataMap.engineerOption = res || []
        })
      },
      handleSalesManFocus() {
        getUrlList('user/dropdown/salesman').then((res: any) => {
          dataMap.salesManOption = res || []
        })
      },
      handleTabClick(item: any) {
        dataMap.activeTab = item.id
      },
      handleResizedEvent(i: any, newH: any, newW: any, newHPx: any) {
        dataMap.newHpx = newHPx
      },
      handleFilterFocus(field: any) {
        if (field.focus) {
          dataMap[field.focus]()
        }
      },
      handleFilterOptions(field: any) {
        if (field.options) {
          return dataMap[field.options]
        }
        return []
      }
    })
    const { mixinData } = mixin(dataMap)

    const splitter = useTableSplitter({
      storageKey: 'erp.split_ratio./order/invoiceBusiness',
      defaultRatio: 0.38,
      minTopHeight: 140,
      minBottomHeight: 0,
      splitterHeight: 22,
      paginationHeight: 52,
      onResize: (topH) => {
        dataMap.newHpx = topH
      }
    })

    watch(() => mixinData.isFilterCollapse, () => {
      setTimeout(() => {
        splitter.applyLayout()
      }, 50)
    })
    onMounted(async() => {
      mixinData.initHeight()

      dataMap.listQuery.startTime = defaultDate[0]
      dataMap.listQuery.endTime = defaultDate[1]
      dataMap.getList()
      dataMap.getDropdownList()
    })
    return { t, ...toRefs(dataMap), ...toRefs(mixinData),
      ...splitter,
      handleSubMenuCollapse: splitter.toggleSubMenuCollapse, tableListRef }
  }
})
</script>
<style  lang="scss">
.grid-layout-container {
.vue-grid-item {
  background:#666 ;
}
}
</style>
<style  lang="scss" scope>
.statusStyle{
  .status{
    // border: 1px solid;
    padding: 0 4px;
    border-radius: 6px;
    margin-right: 7px;
    font-size: 10px;
    color:#fff;
  }
}
.redStatusStyle{
  .icon-tubiao-40{
    color:#E74228;
  }
  .status{
    background-color:#E74228;
  }
}
.yellowStatusStyle{
  .icon-tubiao-40{
    color:#F3D03C;
  }
  .status{
    background-color:#F3D03C;
  }
}
.warming-fp{
  border-radius: 4px;
  border: 1px solid $red;
  color:$red;
  padding: 8px;
  margin-bottom: 20px;
}
</style>
